module.exports = __webpack_public_path__ + "static/media/bank-swedbank.66356882.svg";